export default __webpack_public_path__ + "static/media/energoLogo.8454b1fc.svg";